import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

@Injectable({
  providedIn: 'root',
})
export class FaceDbService {
  private dbPromise: Promise<IDBPDatabase>;

  constructor() {
    this.dbPromise = this.initDB();
  }

  // Initialize IndexedDB
  private async initDB() {
    return openDB('FaceDatabase', 1, {
      upgrade(db) {
        // Create object store for face images
        if (!db.objectStoreNames.contains('extractedFaces')) {
          db.createObjectStore('extractedFaces', {
            keyPath: 'id',
            autoIncrement: true,
          });
        }
      },
    });
  }

  // Save face images array (replaces previous data)
  async persistFaces(faces: { image: string; data: any }[]) {
    const db = await this.dbPromise;
    const tx = db.transaction('extractedFaces', 'readwrite');
    const store = tx.objectStore('extractedFaces');

    await store.clear(); // Clear previous faces
    for (const face of faces) {
      await store.put(face); // Store each face, auto-incremented key
    }
    await tx.done;
  }

  // Get all stored face images
  async getFaces(): Promise<{ image: string; data: any }[]> {
    const db = await this.dbPromise;
    return await db.getAll('extractedFaces');
  }

  // Clear all stored faces
  async clearFaces() {
    const db = await this.dbPromise;
    const tx = db.transaction('extractedFaces', 'readwrite');
    await tx.objectStore('extractedFaces').clear();
    await tx.done;
  }
}
